import { saveSettings } from '@capital-access/common/user';
import { GLOBALIZATION_SECTION_KEY, GlobalizationSettings } from '../models/globalization';

export const saveGlobalizationSetting = (data: GlobalizationSettings) =>
  saveSettings(GlobalizationSettings, { section: GLOBALIZATION_SECTION_KEY, data });
